import { axiosInstance, configHeader } from "./configURL";

export const jobServices = {
  getContact: (data) => {
    return axiosInstance.post(
      "/recruitment/contact",
      { params: data },
      configHeader
    );
  },
  getJob: (url) => {
    return axiosInstance.get("/recruitment/job_position" + url, configHeader);
  },

  getJobOfficial: (url) => {
    return axiosInstance.get(
      "/recruitment/job_position?page=1&limit=3&job_type_id=1",
      configHeader
    );
  },

  getJobSession: (url) => {
    return axiosInstance.get(
      "/recruitment/job_position?page=1&limit=3&job_type_id=2",
      configHeader
    );
  },
  getJobType: () => {
    return axiosInstance.get("/recruitment/job_type", configHeader);
  },

  getBanner: () => {
    return axiosInstance.get("/recruitment/banner", configHeader);
  },
  getJobDetails: (id) => {
    return axiosInstance.get("/recruitment/job_position/" + id);
  },
  checkJob: (data) => {
    return axiosInstance.post(
      "/recruitment/result",
      { params: data },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  },
  applyJob: (data) => {
    return axiosInstance.post(
      "/recruitment/apply_cv",
      { params: data },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  },
  listNew: (page, limit) => {
    return axiosInstance.get(
      `/recruitment/news?page=${page}&limit=${limit}`,
      configHeader
    );
  },
  detailsNew: (id) => {
    return axiosInstance.get(`/recruitment/news-details/${id}`, configHeader);
  },
};
